const acc = document.getElementsByClassName("accordion");
let ii;

for (ii = 0; ii < acc.length; ii++) {
  acc[ii].addEventListener("click", function() {
    this.classList.toggle("active");
    const panel = this.nextElementSibling;
    if (panel.style.maxHeight && panel.style.paddingBottom) {
      panel.style.maxHeight = null;
      panel.style.paddingBottom = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 30 + "px";
      panel.style.paddingBottom = "30px";
    }
  });
}

const addToCartBtn = document.querySelector("#AddToCart");
const findInstallerBtn = document.querySelector("#findInstaller");
const priceList = document.querySelector("[data-product-price-list]")
const priceListSticky = document.querySelector("[data-product-form-price-sticky]")
const priceTemplatePOA = () => {
  return `
  <span class="price price--large">
            <span class="visually-hidden">Sale price</span>
POA</span>
  `
}

function CustomBtnTypeCheck(type){
  if(type=="POA"){
    addToCartBtn.style.display = "none"
    findInstallerBtn.style.display = "block"
    priceList.innerHTML = priceTemplatePOA();
    priceListSticky.innerHTML = priceTemplatePOA();
  }
  if(type==null){
    addToCartBtn.style.display = "block"
    findInstallerBtn.style.display = "none"
  }

}

const upsellBtn = document.querySelectorAll(".upsellAddToCart");

if(upsellBtn.length > 0){
  upsellBtn.forEach( (u, index) => {
    const variantId = u.getAttribute("data-id");
    const quantityElement = document.querySelectorAll('.quantity')
    u.addEventListener('click', (e) => {
      e.preventDefault();
      console.log('index', index)
      const quantity = quantityElement[index].value
      ajaxAdd(variantId, parseInt(quantity));
    })
  })
}

async function getCartData(){
  const response = await fetch(window.Shopify.routes.root + 'cart.js')
  
  return response.json()
}

function ajaxAdd(variantId, quantity){
  let productData = {
    'items': [{
      'id': variantId,
      'quantity': quantity
    }]
  };
 fetch(window.Shopify.routes.root + 'cart/add.js', {
   method: 'POST',
   headers: {
     'Content-Type': 'application/json'
   },
   body: JSON.stringify(productData)
 })
 .then(response => {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true
    }));
    document.getElementById("mini-cart").open = true;
   return response.json();
 })
 .catch((error) => {
   console.error('Error:', error);
 });
}

(function initProductAddons() {
  const hasFlat = document.querySelector("[data-addon-products]");
  const hasGroup = document.querySelector("[data-addon-products-group]");
  if (!hasFlat && !hasGroup) return;

  const basePriceEl =
    document.querySelector("[data-addon-products][data-base-price-cents]") ||
    document.querySelector("[data-addon-products-group][data-base-price-cents]");
  let basePriceCents = basePriceEl
    ? parseInt(basePriceEl.getAttribute("data-base-price-cents"), 10) || 0
    : 0;

  function getMoneyFormat() {
    const settings = (window.themeVariables && window.themeVariables.settings) || {};
    // Match main PDP display ($2,070.00) rather than forcing currency-code suffix
    return (
      settings.moneyFormat ||
      (window.Shopify && window.Shopify.money_format) ||
      "${{amount}}"
    );
  }

  function formatAddonMoney(cents) {
    const format = getMoneyFormat();
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(cents, format);
    }
    if (window.Shopify && typeof window.Shopify.tbFormatMoney === "function") {
      return window.Shopify.tbFormatMoney(cents, format);
    }
    return (cents / 100).toFixed(2);
  }

  function isEligibleCheckbox(checkbox) {
    const panel = checkbox.closest("[data-addon-group-panel]");
    return !panel || !panel.hasAttribute("hidden");
  }

  function getEligibleCheckedCheckboxes() {
    return Array.from(document.querySelectorAll("[data-addon-checkbox]:checked")).filter(
      isEligibleCheckbox
    );
  }

  function getCheckedAddonCents() {
    return getEligibleCheckedCheckboxes().reduce(
      (sum, checkbox) => sum + (parseInt(checkbox.getAttribute("data-price-cents"), 10) || 0),
      0
    );
  }

  function getCheckedAddonItems(quantity) {
    return getEligibleCheckedCheckboxes().map((checkbox) => ({
      id: parseInt(checkbox.getAttribute("data-variant-id"), 10),
      quantity: quantity,
    }));
  }

  function getMainPriceListElements() {
    const selectors = [
      ".shopify-section--main-product .product-meta__price-list-container.main_product [data-product-price-list]",
      ".shopify-section--main-product product-meta [data-product-price-list]",
      ".shopify-section--main-product [data-product-price-list]",
      "[data-product-form-price-sticky] [data-product-price-list]",
      "[data-product-form-price-sticky].product-meta__price-list-container",
    ];
    const elements = [];
    selectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((el) => {
        if (!elements.includes(el)) elements.push(el);
      });
    });
    return elements;
  }

  function updateDisplayedPrice() {
    const targets = getMainPriceListElements();
    if (!targets.length) return;

    const totalCents = basePriceCents + getCheckedAddonCents();
    const formatted = formatAddonMoney(totalCents);

    targets.forEach((el) => {
      const dealerLabel = el.querySelector(".dealer_price_label");
      const existingPrice = el.querySelector(".price:not(.price--compare)");
      const priceClass =
        existingPrice && existingPrice.classList.contains("price--large")
          ? "price price--large"
          : existingPrice && existingPrice.className
            ? existingPrice.className
            : "price price--large";

      let html = "";
      if (dealerLabel) html += dealerLabel.outerHTML;
      html += `<span class="${priceClass}"><span class="visually-hidden">Sale price</span>${formatted}</span>`;
      el.innerHTML = html;
    });
  }

  function schedulePriceUpdate() {
    requestAnimationFrame(updateDisplayedPrice);
  }

  function syncBasePriceAttrs() {
    document.querySelectorAll("[data-base-price-cents]").forEach((el) => {
      if (el.hasAttribute("data-addon-products") || el.hasAttribute("data-addon-products-group")) {
        el.setAttribute("data-base-price-cents", String(basePriceCents));
      }
    });
  }

  function setActiveGroup(root, selectedHandle) {
    const handle = (selectedHandle || "").trim();
    const isNone = handle === "";

    root.querySelectorAll("[data-addon-group-panel]").forEach((panel) => {
      const isActive = !isNone && panel.getAttribute("data-addon-group-panel") === handle;
      if (isActive) {
        panel.removeAttribute("hidden");
        return;
      }

      panel.setAttribute("hidden", "");
      panel.querySelectorAll("[data-addon-checkbox]").forEach((checkbox) => {
        checkbox.checked = false;
      });
    });

    // None: force-clear every checkbox in this group block
    if (isNone) {
      root.querySelectorAll("[data-addon-checkbox]").forEach((checkbox) => {
        checkbox.checked = false;
      });
    }

    schedulePriceUpdate();
  }

  document.querySelectorAll("[data-addon-checkbox]").forEach((checkbox) => {
    checkbox.addEventListener("change", schedulePriceUpdate);
  });

  document.querySelectorAll("[data-addon-products-group]").forEach((root) => {
    const select = root.querySelector("[data-addon-group-select]");
    if (!select) return;

    setActiveGroup(root, select.value);

    select.addEventListener("change", function () {
      setActiveGroup(root, this.value);
    });
  });

  document.addEventListener("variant:changed", function (event) {
    const variant = event.detail && event.detail.variant;
    if (!variant || typeof variant.price === "undefined") return;
    basePriceCents = parseInt(variant.price, 10) || 0;
    syncBasePriceAttrs();
    schedulePriceUpdate();
  });

  document.addEventListener(
    "submit",
    async function (event) {
      const form = event.target;
      if (!form || form.getAttribute("is") !== "product-form") return;

      const checkedBoxes = getEligibleCheckedCheckboxes();
      if (checkedBoxes.length === 0) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const idInput = form.elements.namedItem("id");
      const quantityInput = form.elements.namedItem("quantity");
      const mainVariantId = idInput && idInput.value ? parseInt(idInput.value, 10) : null;
      const mainQty = quantityInput && quantityInput.value ? parseInt(quantityInput.value, 10) : 1;

      if (!mainVariantId || isNaN(mainVariantId)) return;

      const quantity = !mainQty || isNaN(mainQty) || mainQty < 1 ? 1 : mainQty;
      const addonItems = getCheckedAddonItems(quantity);

      const mainItem = {
        id: mainVariantId,
        quantity: quantity,
      };

      const noteInput = form.elements.namedItem("properties[Note]");
      if (noteInput && noteInput.value) {
        mainItem.properties = { Note: noteInput.value };
      }

      const submitButtons = Array.from(form.elements).filter((el) => el.type === "submit");
      submitButtons.forEach((button) => {
        button.setAttribute("disabled", "disabled");
        button.setAttribute("aria-busy", "true");
      });

      const cartAddUrl =
        (window.themeVariables &&
          window.themeVariables.routes &&
          window.themeVariables.routes.cartAddUrl) ||
        window.Shopify.routes.root + "cart/add";

      try {
        const response = await fetch(`${cartAddUrl}.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({
            items: [mainItem, ...addonItems],
            sections: ["mini-cart"],
          }),
        });

        const responseJson = await response.json();

        submitButtons.forEach((button) => {
          button.removeAttribute("disabled");
          button.removeAttribute("aria-busy");
        });

        if (response.ok) {
          form.dispatchEvent(
            new CustomEvent("variant:added", {
              bubbles: true,
              detail: {
                variant: responseJson.hasOwnProperty("items")
                  ? responseJson.items[0]
                  : responseJson,
              },
            })
          );

          const cartUrl =
            (window.themeVariables &&
              window.themeVariables.routes &&
              window.themeVariables.routes.cartUrl) ||
            window.Shopify.routes.root + "cart";

          const cartResponse = await fetch(`${cartUrl}.js`);
          const cartContent = await cartResponse.json();

          document.documentElement.dispatchEvent(
            new CustomEvent("cart:updated", {
              bubbles: true,
              detail: { cart: cartContent },
            })
          );

          cartContent.sections = responseJson.sections;
          document.documentElement.dispatchEvent(
            new CustomEvent("cart:refresh", {
              bubbles: true,
              detail: {
                cart: cartContent,
                openMiniCart:
                  window.themeVariables &&
                  window.themeVariables.settings &&
                  window.themeVariables.settings.cartType === "drawer" &&
                  form.closest(".drawer") === null,
              },
            })
          );
        }

        form.dispatchEvent(
          new CustomEvent("cart-notification:show", {
            bubbles: true,
            cancelable: true,
            detail: {
              status: response.ok ? "success" : "error",
              error: responseJson.description || "",
            },
          })
        );
      } catch (error) {
        submitButtons.forEach((button) => {
          button.removeAttribute("disabled");
          button.removeAttribute("aria-busy");
        });
        console.error("Error adding product with addons:", error);
      }
    },
    true
  );
})();


const zoomBtn = document.querySelector('.product__zoom-button');
const productMedia = document.querySelector('product-media')
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === "attributes") {
       if(mutation.target.ariaExpanded === "true"){
          productMedia.classList.add("force-relative");
       }
       if(mutation.target.ariaExpanded === "false"){
         productMedia.classList.remove("force-relative");
       }
    }
  });
});

if (zoomBtn && productMedia) {
  observer.observe(zoomBtn, {
    attributes: true
  });
}


if (addToCartBtn) {
  const hiddenInput = document.getElementById('product-note-hidden');
  const externalTextarea = document.getElementById('product-note');

  if(externalTextarea) {
    externalTextarea.addEventListener('input', function() {
        hiddenInput.value = this.value;
    });
  }
}

document.querySelectorAll('.cu-product').forEach(row => {
  const minusButton = row.querySelector('.minus');
  const plusButton = row.querySelector('.plus');
  const inputField = row.querySelector('.quantity');
  console.log('minusButton', minusButton)

  minusButton.addEventListener('click', () => {
      let currentValue = parseInt(inputField.value, 10);
      if (currentValue > 1) {
          inputField.value = currentValue - 1;
      }
  });

  plusButton.addEventListener('click', () => {
      let currentValue = parseInt(inputField.value, 10);
      inputField.value = currentValue + 1;
  });

  // This is to ensure that users don't manually enter values less than 1
  inputField.addEventListener('change', () => {
      let currentValue = parseInt(inputField.value, 10);
      if (currentValue < 1 || isNaN(currentValue)) {
          inputField.value = 1;
      }
  });
});
